module.exports = __webpack_public_path__ + "img/imgvalleb.66eea9fc.png";